export default __webpack_public_path__ + "static/char-v-33-ja-f02daf9d1d34a91d47bdd7bf4af52553.mp4";